import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import appSlice from './app.slice';
import leasingSlice from './leasing.slice';
import requestsSlice from './requests.slice';

const rootReducer = combineReducers({
  app: appSlice.reducer,
  leasing: leasingSlice.reducer,
  requests: requestsSlice.reducer
});

export const store = configureStore({
  reducer: rootReducer
});

export const dispatch = store.dispatch.bind(store);
export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;

export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
